import * as React from "react";
const SvgPolyline = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", stroke: "#0B4566", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 28l5-5 5 5 8-8M23 21l-8-8H8", strokeWidth: 2 }));
export default SvgPolyline;
